import { useMemo } from "react";

import {
  type ReviewComponentType,
  ReviewComponentTypeEnum,
} from "../../../types";
import { DislikeIcon, LikeIcon, LoveIcon } from "./icons";

interface ReviewComponentProps {
  component: ReviewComponentType;
}

export default function ReviewComponent({
  component: { options, question, response, shortQuestion, type },
}: ReviewComponentProps) {
  const optionDisplay = useMemo(() => {
    if (type === ReviewComponentTypeEnum.TEXT) {
      return null;
    }

    const option = response.optionId
      ? options.find((o) => o.id === response.optionId)
      : undefined;

    if (!option) {
      return null;
    }

    const { value } = option;

    if (type === ReviewComponentTypeEnum.RATING) {
      if (value === "LOVE") {
        return <LoveIcon />;
      }

      if (value === "LIKE") {
        return <LikeIcon />;
      }

      if (value === "DISLIKE") {
        return <DislikeIcon />;
      }
    }

    return <p className="font-medium text-15/[1.6em] text-white">{value}</p>;
  }, [options, response.optionId, type]);

  return (
    <div>
      <div className="flex items-center justify-between py-2">
        <h6 className="font-medium text-15/[1.6em] text-white">
          {shortQuestion || question}
        </h6>
        {optionDisplay}
      </div>
      {!!response.comment && (
        <p className="pb-2.5 text-14/[1.71em] text-white/80">
          {response.comment}
        </p>
      )}
    </div>
  );
}
